import { formatRowCount } from "../../../logic/services/reportBuilderSummary.js";
import { rbSectionHint } from "../reportBuilderTheme.js";

export function DatasetStep({ datasets, datasetsLoading, datasetId, onSelect, c, A }) {
  return (
    <div>
      <p style={rbSectionHint(c)}>
        Choose a telemetry source. Dataset size directly affects scan cost shown in the inspector.
      </p>
      {datasetsLoading && datasets.length === 0 ? (
        <p style={{ margin: 0, fontSize: 12, color: c.sub }}>Loading datasets…</p>
      ) : (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))", gap: 10 }}>
          {datasets.map((ds) => {
            const selected = ds.id === datasetId;
            return (
              <button
                key={ds.id}
                type="button"
                onClick={() => onSelect(ds.id)}
                style={{
                  textAlign: "left",
                  padding: "14px 16px",
                  borderRadius: 12,
                  border: `2px solid ${selected ? A : c.cardBdr}`,
                  background: selected ? `${A}10` : c.card,
                  cursor: "pointer",
                  boxShadow: selected ? `0 0 0 1px ${A}22` : "none",
                }}
              >
                <div style={{ fontSize: 14, fontWeight: 700, color: c.text, marginBottom: 6 }}>{ds.name}</div>
                <div style={{ fontSize: 12, color: c.sub, lineHeight: 1.45, marginBottom: 10, minHeight: 34 }}>{ds.description}</div>
                <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                  {[
                    { label: "Rows", value: formatRowCount(ds.rows) },
                    { label: "Size", value: ds.scanSize },
                    { label: "Fields", value: ds.fieldCount },
                  ].map((stat) => (
                    <span
                      key={stat.label}
                      style={{
                        fontSize: 10,
                        fontWeight: 700,
                        letterSpacing: "0.04em",
                        textTransform: "uppercase",
                        color: selected ? A : c.sub,
                        background: selected ? `${A}16` : c.hover,
                        padding: "3px 8px",
                        borderRadius: 6,
                      }}
                    >
                      {stat.label}: {stat.value}
                    </span>
                  ))}
                </div>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
